export default "__VITE_ASSET__7RkR8BYu__"